module.exports = "https://d1tntvpcrzvon2.cloudfront.net/vpassets/_next/static/images/free_shipping-658bce579480081334bb024d741385e0.svg";